import { useState } from 'react'
import { createPortal } from 'react-dom'
import type { Game } from '../../types/game'
import { ResourceIcon } from '../shared/ResourceIcon'

const POLLEN_PER_PROPOLIS = 4

interface WinterTradeModalProps {
  game: Game
  myColor: string
  onTrade: (nPropolis: number) => void
}

export function WinterTradeModal({ game, myColor, onTrade }: WinterTradeModalProps) {
  const [nPropolis, setNPropolis] = useState(0)

  const player = game.players.find((candidate) => candidate.color === myColor)
  if (!player) return null

  const maxPropolis = Math.floor((player.resources.pollen ?? 0) / POLLEN_PER_PROPOLIS)
  const appRoot = document.querySelector('.app') ?? document.body

  return createPortal(
    <div className="nesting-modal-root">
      <div className="nesting-modal-overlay" />
      <div className="nesting-modal tableau">
        <div className="nesting-modal-options winter-trade-modal">
          <div className="woolly-fur-modal-title">Winter Market</div>
          <div className="winter-trade-modal-hint">
            Trade {POLLEN_PER_PROPOLIS} <ResourceIcon resource="pollen" /> for 1{' '}
            <ResourceIcon resource="propolis" /> — as often as you can afford.
          </div>
          <div className="winter-trade-modal-controls">
            <input
              className="input"
              type="number"
              min={0}
              max={maxPropolis}
              value={nPropolis}
              onChange={(event) =>
                setNPropolis(Math.min(maxPropolis, Math.max(0, parseInt(event.target.value, 10) || 0)))
              }
            />
            <ResourceIcon resource="propolis" />
            <span className="winter-trade-modal-cost">
              (−{nPropolis * POLLEN_PER_PROPOLIS} <ResourceIcon resource="pollen" />)
            </span>
          </div>
          <div className="nesting-modal-option-row">
            <div className="lobby-start" onClick={() => onTrade(nPropolis)}>
              {nPropolis > 0 ? 'Trade' : 'Skip'}
            </div>
          </div>
        </div>
      </div>
    </div>,
    appRoot
  )
}
